export default "76f9261347525a2e.svg"